import { createTheme } from '@material-ui/core/styles'
const CustomTheme = createTheme({
    direction: "ltr",
    typography: {
        fontFamily: "Vazir"
    }
})

export default CustomTheme